// Libs
import { TranslationService } from '@/utils/services/TranslationService';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import { CommunityConfig } from '@/lib/analytics/pages/community';
import { ANALYZE_COMMUNITY } from '@/lib/routes/privateRoutes';

// Components
import { LayoutAnalytics } from '@/components/layouts/wrappers/LayoutAnalytics';
import { WrapperSwitchLayout } from '@/components/layouts/wrappers/WrapperSwitchLayout';

const Community = () => {
    const { t: tCommons } = useTranslation('commons');

    return (
        <WrapperSwitchLayout>
            <LayoutAnalytics profileConfig={CommunityConfig} title={tCommons('menu.community')} />
        </WrapperSwitchLayout>
    );
};

export const getStaticProps = TranslationService.getTranslationMessagesFromRoute(ANALYZE_COMMUNITY);

export default Community;
